document.addEventListener('DOMContentLoaded', function() {
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',

    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('[data-lang-button]'),
          panel: this.querySelector('[data-lang-list]'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      onContainerKeyUp(event) {
        if (event.code.toUpthemeperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    }
  );
}

  const notification = document.getElementById('CartNotification');
  if (notification) {
    let lastTrigger = null;
    const imageWrap = notification.querySelector('[data-cart-notification-image-wrap]');
    const imageEl = notification.querySelector('[data-cart-notification-image]');
    const titleEl = notification.querySelector('[data-cart-notification-title]');
    const variantEl = notification.querySelector('[data-cart-notification-variant]');
    const propertiesEl = notification.querySelector('[data-cart-notification-properties]');
    const quantityWrap = notification.querySelector('.cart-notification__quantity');
    const quantityEl = notification.querySelector('[data-cart-notification-quantity]');
    const errorEl = notification.querySelector('[data-cart-notification-error]');
    const productEl = notification.querySelector('.cart-notification__product');
    const headingEl = document.getElementById('CartNotificationHeading');
    const actionsEl = notification.querySelector('.cart-notification__actions');
    const addUrl = notification.getAttribute('data-add-url') || '/cart/add.js';
    const cartUrl = notification.getAttribute('data-cart-url') || '/cart.js';
    const addingLabel = notification.getAttribute('data-adding') || (window.theme && theme.strings && theme.strings.cartNotificationAdding);
    const errorLabel = notification.getAttribute('data-error') || (window.theme && theme.strings && theme.strings.cartNotificationError);

    function isAddToCartForm(form) {
      if (!form || form.tagName !== 'FORM') return false;
      const action = form.getAttribute('action') || '';
      return action.indexOf('/cart/add') !== -1;
    }

    function setHidden(el, hidden) {
      if (!el) return;
      if (hidden) {
        el.classList.add('hide');
      } else {
        el.classList.remove('hide');
      }
    }

    function openNotification() {
      notification.classList.add('is-open');
      notification.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-notification-open');
      const focusTarget = notification.querySelector('.cart-notification__cart-btn') || notification.querySelector('[data-cart-notification-close]');
      if (focusTarget) focusTarget.focus();
    }

    function closeNotification() {
      notification.classList.remove('is-open');
      notification.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-notification-open');
      if (lastTrigger && typeof lastTrigger.focus === 'function') {
        lastTrigger.focus();
      }
    }

    function showError(message) {
      setHidden(productEl, true);
      setHidden(headingEl, true);
      setHidden(actionsEl, true);
      errorEl.textContent = message || errorLabel;
      setHidden(errorEl, false);
      openNotification();
    }

    function cleanMwOptionLabel(value) {
      if (!value) return '';
      return String(value).split('#MWS')[0].trim();
    }

    function getVariantLabel(item, form) {
      if (form) {
        const selectorLabels = Array.from(form.querySelectorAll('.single-option-selector'))
          .map((select) => {
            const selected = select.options[select.selectedIndex];
            const label = cleanMwOptionLabel(selected ? selected.text : '');
            if (!label || label === 'Default Title') return '';
            return label;
          })
          .filter(Boolean);

        if (selectorLabels.length) {
          return selectorLabels.join(' / ');
        }
      }

      if (item.variant_options && item.variant_options.length) {
        return item.variant_options
          .map(cleanMwOptionLabel)
          .filter((label) => label && label !== 'Default Title')
          .join(' / ');
      }

      const variantTitle = item.variant_title || '';
      if (!variantTitle || variantTitle === 'Default Title') return '';

      return variantTitle
        .split(' / ')
        .map(cleanMwOptionLabel)
        .filter(Boolean)
        .join(' / ');
    }

    function isHiddenPropertyKey(key) {
      if (!key) return true;
      return key.indexOf('_mw') !== -1 || key.charAt(0) === '_';
    }

    function getPropertiesFromForm(form) {
      if (!form) return {};

      const formData = new FormData(form);
      const properties = {};

      formData.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (!match) return;
        properties[match[1]] = value;
      });

      return properties;
    }

    function getMwOptionsFromDom(form) {
      if (!form) return [];

      const root = form.querySelector('.mw-product-options');
      if (!root) return [];

      const lines = [];

      root.querySelectorAll('select').forEach((select) => {
        const selected = select.options[select.selectedIndex];
        if (!selected) return;

        const valueText = (selected.textContent || selected.text || '').trim();
        if (!valueText) return;

        let name = '';
        if (select.id) {
          const label = form.querySelector('label[for="' + select.id.replace(/"/g, '') + '"]');
          if (label) name = label.textContent.trim();
        }

        if (!name) {
          const wrapper = select.closest('.option-item, .mw-option, .drop-down-option, .option-container, .has-mw-options');
          const title = wrapper && wrapper.querySelector('label, .option-title, .mw-option-title');
          if (title) name = title.textContent.trim();
        }

        lines.push(name ? name + ': ' + valueText : valueText);
      });

      root.querySelectorAll('.button-value--selected, .swatch-selected, [aria-selected="true"]').forEach((el) => {
        const valueText = (el.textContent || '').trim();
        if (!valueText) return;
        lines.push(valueText);
      });

      return lines;
    }

    function getVisiblePropertyLines(item, form) {
      const properties = Object.assign({}, getPropertiesFromForm(form), item && item.properties);
      const lines = [];

      Object.keys(properties).forEach((key) => {
        const value = properties[key];
        if (isHiddenPropertyKey(key) || value === null || value === undefined || value === '') return;
        if (String(key).toLowerCase().indexOf('quantity') !== -1) return;

        const displayValue = Array.isArray(value) ? value.join(', ') : String(value);
        if (!displayValue.trim()) return;

        if (displayValue.indexOf('/uploads/') !== -1) {
          lines.push(key + ': ' + displayValue.split('/').pop());
          return;
        }

        lines.push(key + ': ' + displayValue);
      });

      if (!lines.length) {
        return getMwOptionsFromDom(form);
      }

      return lines;
    }

    function renderProperties(item, form) {
      const lines = getVisiblePropertyLines(item, form);
      propertiesEl.innerHTML = '';

      if (!lines.length) {
        setHidden(propertiesEl, true);
        return;
      }

      lines.forEach((line) => {
        const lineEl = document.createElement('p');
        lineEl.className = 'cart-notification__property';
        lineEl.textContent = line;
        propertiesEl.appendChild(lineEl);
      });

      setHidden(propertiesEl, false);
    }

    function findCartItem(cart, addedItem) {
      if (!cart || !cart.items || !cart.items.length) return addedItem;

      return cart.items.find((line) => addedItem.key && line.key === addedItem.key)
        || cart.items.find((line) => line.id === addedItem.id || line.variant_id === addedItem.variant_id)
        || cart.items[0];
    }

    function showSuccess(item, form) {
      const variantTitle = getVariantLabel(item, form);
      const isDefaultVariant = !variantTitle;

      titleEl.textContent = item.product_title || item.title || '';
      variantEl.textContent = variantTitle;
      setHidden(variantEl, isDefaultVariant);
      renderProperties(item, form);

      if (item.quantity) {
        quantityEl.textContent = item.quantity;
        setHidden(quantityWrap, false);
      } else {
        setHidden(quantityWrap, true);
      }

      if (item.image) {
        imageEl.src = item.image;
        imageEl.alt = item.product_title || '';
        setHidden(imageWrap, false);
      } else {
        imageEl.removeAttribute('src');
        setHidden(imageWrap, true);
      }

      errorEl.textContent = '';
      setHidden(errorEl, true);
      setHidden(productEl, false);
      setHidden(headingEl, false);
      setHidden(actionsEl, false);
      openNotification();
    }

    function updateCartCount(itemCount) {
      let countEl = document.getElementById('CartCount');
      const cartLink = document.querySelector('.site-header__cart');

      if (!countEl && cartLink) {
        countEl = document.createElement('div');
        countEl.id = 'CartCount';
        countEl.className = 'site-header__cart-count';
        countEl.innerHTML = '<span data-cart-count></span>';
        cartLink.appendChild(countEl);
      }

      if (!countEl) return;

      const numberEl = countEl.querySelector('[data-cart-count]') || countEl.querySelector('span');
      if (numberEl) numberEl.textContent = itemCount;
      setHidden(countEl, !itemCount);
    }

    function refreshCart(addedItem, form) {
      return fetch(cartUrl, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          const cartItem = findCartItem(cart, addedItem);
          if (cartItem) renderProperties(cartItem, form);
          return cart;
        })
        .catch(function() {});
    }

    function setSubmitting(form, isSubmitting) {
      const button = form.querySelector('[name="add"], [type="submit"]');
      const buttonText = form.querySelector('[id^="AddToCartText"]');
      if (!button) return;

      button.disabled = isSubmitting;

      if (!buttonText) return;

      if (isSubmitting) {
        button.setAttribute('data-original-label', buttonText.textContent);
        buttonText.textContent = addingLabel;
      } else {
        const original = button.getAttribute('data-original-label');
        if (original) buttonText.textContent = original;
        button.removeAttribute('data-original-label');
      }
    }

    function addToCart(form) {
      setSubmitting(form, true);

      fetch(addUrl, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function(response) {
          return response.json().then(function(data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function(result) {
          if (!result.ok) {
            showError(result.data.description || result.data.message || errorLabel);
            return;
          }
          showSuccess(result.data, form);
          refreshCart(result.data, form);
        })
        .catch(function() {
          showError(errorLabel);
        })
        .then(function() {
          setSubmitting(form, false);
        });
    }

    document.addEventListener('submit', function(event) {
      const form = event.target;
      if (!isAddToCartForm(form)) return;
      event.preventDefault();
      lastTrigger = form.querySelector('[name="add"], [type="submit"]');
      addToCart(form);
    });

    notification.addEventListener('click', function(event) {
      const closeTrigger = event.target.closest('[data-cart-notification-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeNotification();
      }
    });

    document.addEventListener('keyup', function(event) {
      if ((event.key === 'Escape' || event.keyCode === 27) && notification.classList.contains('is-open')) {
        closeNotification();
      }
    });
  }
});